import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, ViewEncapsulation } from '@angular/core';
import { DisplayErrorService } from 'app/core/display-error/display-error.service';
import { Subject, takeUntil } from 'rxjs';
import { AppConfig } from 'app/config/service.config';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { SharedModule } from 'shared/shared.module';

@Component({
    selector       : 'display-error',
    templateUrl    : './display-error.component.html',
    encapsulation  : ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone     : true,
    imports     : [
        RouterModule,
        CommonModule,
        SharedModule,
        MatIconModule
    ]
})
export class DisplayErrorComponent
{
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    error: {
        type        : string;
        code        : string;
        title       : string;
        message     : string;
        aftereffect?: 'reload' | 'back';
    } = null;
    loggingLevel: number = null;

    /**
     * Constructor
     */
    constructor(
        private _displayErrorService: DisplayErrorService,
        private _apiServer: AppConfig,
        private _changeDetectorRef: ChangeDetectorRef
    )
    {
        this.loggingLevel = this._apiServer.settings.logging;

        // Subscribe to show error message
        this._displayErrorService.errorMessage$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((response) => {

                if (response) {
                    this.error = response;
                }
                // Mark for check
                this._changeDetectorRef.markForCheck();
            });
    }

    doAction()
    {
        if (this.error && this.error.aftereffect) {
            if (this.error.aftereffect === "reload"){
                // Reload the app
                location.reload();
                return;
            } else {
                window.history.back();
                return;
            }
        } else{
            window.history.back();
            return;
        }
    }
}
